<template>
  <div v-title="this.$route.params.id > 0 ? '修改查理宝任务模板' : '添加查理宝任务模板'">
    <div style="padding-bottom:20px;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/clb-task-template/table' }">查理宝任务模板</el-breadcrumb-item>
        <el-breadcrumb-item v-if="this.$route.params.id > 0">修改任务模板</el-breadcrumb-item>
        <el-breadcrumb-item v-else>添加任务模板</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :show-header="false"
                  style="padding-top: 35px;">
      <el-form ref="taskTplForm"
               :model="taskTplForm"
               :rules="taskTplFormRules"
               size="medium"
               label-width="140px"
               class="layout-submit-form"
               @keyup.enter.native="onSubmit()">
        <el-form-item label="模板标题"
                      class="medium"
                      prop="title">
          <el-input v-model="taskTplForm.title"
                    placeholder="请输入模板标题"></el-input>
        </el-form-item>
        <el-form-item label="模板描述"
                      class="medium"
                      prop="detail">
          <el-input v-model="taskTplForm.detail"
                    placeholder="请输入模板描述"
                    type="textarea"
                    :autosize="{ minRows: 2 }"
                    resize="none"></el-input>
        </el-form-item>
        <el-form-item label="客户白名单"
                      class="medium">
          <el-select style="width: 100%;"
                     v-model="taskTplForm.customerid"
                     filterable
                     remote
                     clearable
                     placeholder="请输入客户名称、客户编号"
                     :remote-method="customerRemoteMethod"
                     :loading="selectLoading">
            <el-option v-for="item in customerItems"
                       :key="item.id"
                       :label="item.name + '/' + item.number"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form ref="taskForm"
               :model="form"
               :rules="taskFormRules"
               size="medium"
               label-width="140px"
               class="layout-submit-form"
               @keyup.enter.native="onSubmit()">
        <el-form-item label="任务标题"
                      class="medium"
                      prop="title">
          <el-input v-model="form.title"
                    placeholder="请输入任务标题"></el-input>
        </el-form-item>
        <el-form-item label="任务描述"
                      class="medium"
                      prop="content">
          <wang-editor v-model="form.content"
                       :menus="['head','bold','italic','underline','strikeThrough','foreColor','list','justify','quote','table','undo','redo']"
                       :colors="['#f3605b', '#333']"></wang-editor>
        </el-form-item>
        <el-form-item label="任务类型"
                      class="small">
          <el-select v-model="form.type"
                     placeholder="请选择任务类型"
                     style="width: 100%;">
            <el-option v-for="item in typeItems"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="需要人数"
                      class="mini"
                      prop="hirenum">
          <el-input v-model="form.hirenum">
            <template slot="append">个</template>
          </el-input>
        </el-form-item>
        <el-form-item label="有效签到距离/Km"
                      class="mini"
                      prop="validcheckindistance">
          <el-input v-model="form.validcheckindistance">
            <template slot="append">公里</template>
          </el-input>
        </el-form-item>
        <el-form-item label="完成时限"
                      class="mini"
                      prop="processingtime">
          <el-input v-model="form.processingtime">
            <template slot="append">小时</template>
          </el-input>
        </el-form-item>
        <el-form-item label="审核周期"
                      class="mini"
                      prop="reviewtime">
          <el-input v-model="form.reviewtime">
            <template slot="append">天</template>
          </el-input>
        </el-form-item>
        <el-form-item label="任务提交GPS验证"
                      size="mini">
          <el-radio-group v-model="form.gpsCheck">
            <el-radio-button :label="1">验证</el-radio-button>
            <el-radio-button :label="0">不验证</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="任务置顶"
                      size="mini">
          <el-radio-group v-model="form.priority">
            <el-radio-button :label="0">不置顶</el-radio-button>
            <el-radio-button :label="1">置顶</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="附近人员抢单"
                      size="mini">
          <el-radio-group v-model="form.nearby">
            <el-radio-button :label="1">准许</el-radio-button>
            <el-radio-button :label="0">不准许</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="店内人员优先"
                      size="mini">
          <el-radio-group v-model="form.inhouseprior">
            <el-radio-button :label="0">不优先</el-radio-button>
            <el-radio-button :label="1">优先</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="任务显示"
                      size="mini">
          <el-radio-group v-model="form.onlynearby">
            <el-radio-button :label="0">不限制</el-radio-button>
            <el-radio-button :label="1">仅在周边显示</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="金牌人员优先"
                      size="mini">
          <el-radio-group v-model="form.superuserprior">
            <el-radio-button :label="1">优先</el-radio-button>
            <el-radio-button :label="0">不优先</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="多次接单"
                      size="mini">
          <el-radio-group v-model="form.multitimes">
            <el-radio-button :label="0">不准许</el-radio-button>
            <el-radio-button :label="1">准许</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核不通过重复执行"
                      size="mini">
          <el-radio-group v-model="form.rejectuserrepeat">
            <el-radio-button :label="1">用户准许</el-radio-button>
            <el-radio-button :label="0">用户不准许</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label=""
                      size="mini">
          <el-radio-group v-model="form.rejecttaskrepeat">
            <el-radio-button :label="1">任务准许</el-radio-button>
            <el-radio-button :label="0">任务不准许</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="众包审核照片"
                      size="mini">
          <el-radio-group v-model="form.iscsimage"
                          disabled>
            <el-radio-button :label="1">是</el-radio-button>
            <el-radio-button :label="0">否</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="众包Key-in"
                      size="mini">
          <el-radio-group v-model="form.iscskeyin"
                          disabled>
            <el-radio-button :label="1">是</el-radio-button>
            <el-radio-button :label="0">否</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发布平台"
                      size="mini">
          <el-radio-group v-model="form.ostype">
            <el-radio-button :label="0">不限制</el-radio-button>
            <el-radio-button :label="10">Android</el-radio-button>
            <el-radio-button :label="20">iOS</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="适用检查类型"
                      size="mini">
          <el-radio-group v-model="form.prod_type">
            <el-radio-button :label="0">SKU</el-radio-button>
            <el-radio-button :label="1">品牌</el-radio-button>
            <el-radio-button :label="2">活动</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="用户限制类型"
                      size="mini">
          <el-radio-group v-model="formExtend.restrictedType">
            <el-radio-button label="">不限制</el-radio-button>
            <!-- <el-radio-button :label="1">定向用户</el-radio-button> -->
            <el-radio-button label="black">黑名单</el-radio-button>
            <el-radio-button label="white">白名单</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <div v-if="formExtend.restrictedType !== ''">
          <el-form-item label="限制用户"
                        size="mini"
                        class="medium">
            <el-select
              style="width: 100%;"
              v-model="formExtend.userList"
              filterable
              remote
              multiple
              placeholder="请输入用户ID、名称"
              :remote-method="userRemoteMethod"
              :loading="selectLoading">
              <el-option v-for="{userid, cellphone} in userItems"
                         :key="userid"
                         :label="cellphone + '/' + userid"
                         :value="userid"></el-option>
            </el-select>
            <el-button type="text"
                       size="mini"
                       @click="dialogBatchUserListVisible = true">
              批量添加用户
            </el-button>
          </el-form-item>
          <el-form-item label="限制用户标签"
                        size="mini"
                        class="medium">
            <el-select
              style="width: 100%;"
              v-model="formExtend.userTagList"
              filterable
              remote
              multiple
              placeholder="请输入用户标签ID、名称"
              :remote-method="userTagRemoteMethod"
              :loading="selectLoading">
              <el-option v-for="{id,tagname} in userTagItems"
                         :key="id"
                         :label="tagname + '/' + id"
                         :value="id"></el-option>
            </el-select>
            <el-button type="text"
                       size="mini"
                       @click="dialogBatchUserTagListVisible = true">
              批量添加标签
            </el-button>
          </el-form-item>
        </div>
        <el-form-item label="分步模板"
                      size="mini"
                      prop="stepTemplateGroups"
                      style="padding-bottom: 5px;">
          <el-row style="margin-bottom: 5px;">
            <el-button size="mini"
                       @click="addStepTemplateGroup(form.stepTemplateGroups.length)">
              添加模板组
            </el-button>
            <span v-show="form.stepTemplateGroups.length > 0">
              <el-select
                v-model="stepTemplateToAdded"
                filterable
                remote
                placeholder="请输入名称/ID"
                value-key="id"
                :remote-method="stepTemplateRemoteMethod"
                @change="stepTemplateToAddedChange"
                :loading="selectLoading">
                <el-option
                  v-for="item in stepTemplates"
                  :key="item.value"
                  :label="item.title"
                  :value="item">
                  <span>{{ item.title }}</span>
                  <span class="info">id: {{ item.id }}</span>
                </el-option>
              </el-select>
              <el-button :disabled="!stepTemplateToAdded || addStepTemplateButtonDisabled"
                         size="mini"
                         @click="addStepTemplate('primary')">添加到主模板</el-button>
              <el-button :disabled="!stepTemplateToAdded || addStepTemplateButtonDisabled"
                         size="mini"
                         @click="addStepTemplate('secondary')">添加到从模板</el-button>
            </span>
          </el-row>
          <el-row style="margin-top: 10px; margin-bottom: 5px;"
                  v-show="form.stepTemplateGroups.length">
            <el-tabs
              v-model="stepTemplateGroupActiveIndex"
              type="card"
              closable
              @tab-remove="removeStepTemplateGroup">
              <el-tab-pane
                v-for="({name, primary, secondary}, index) in form.stepTemplateGroups"
                :key="index"
                :label="name"
                :name="index.toString()">
                <div class="step-template-panel">
                  <div class="step-template-container border-bottom">
                    <div class="step-template-type"><b>组名称</b></div>
                    <div class="step-template-radio-container">
                      <el-input v-model="form.stepTemplateGroups[index].name"
                                placeholder="请输入模板标题"
                                style="width: 300px;"></el-input>
                    </div>
                  </div>
                  <div class="step-template-container border-bottom">
                    <div class="step-template-type"><b>主模板</b></div>
                    <div class="step-template-radio-container">
                      <el-tooltip v-for="(items, index) in primary"
                                  :key="items.id"
                                  class="item"
                                  effect="dark"
                                  :content="'ID:' + items.id"
                                  placement="top">
                        <el-radio class="step-template-radio"
                                  v-model="stepTemplateSelected"
                                  border
                                  :label="items">
                          <span class="step-template-name">
                            <span>{{items.title}}</span>
                            <span class="step-template-icon">
                              <i v-show="items.required"
                                 class="el-icon-check"></i>
                              <i v-show="items.loop"
                                 class="el-icon-refresh"></i>
                            </span>
                          </span>
                          <span class="el-icon-error step-template-remove"
                                @click.prevent="removeStepTemplate(primary, index)"></span>
                        </el-radio>
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="step-template-container">
                    <div class="step-template-type"><b>从模板</b></div>
                    <div class="step-template-radio-container">
                      <el-tooltip v-for="(items, index) in secondary"
                                  :key="items.id"
                                  class="item"
                                  effect="dark"
                                  :content="'ID:' + items.id"
                                  placement="top">
                        <el-radio class="step-template-radio"
                                  v-model="stepTemplateSelected"
                                  border
                                  :label="items">
                          <span class="step-template-name">
                            <span>{{items.title}}</span>
                            <span class="step-template-icon">
                              <i v-show="items.required"
                                 class="el-icon-check"></i>
                              <i v-show="items.loop"
                                 class="el-icon-refresh"></i>
                            </span>
                          </span>
                          <span class="el-icon-error step-template-remove"
                                @click.prevent="removeStepTemplate(secondary, index)"></span>
                        </el-radio>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
            <div v-if="stepTemplateSelected"
                 style="padding-top: 10px;">
              <el-checkbox v-model="stepTemplateSelected.required">必选</el-checkbox>
              <el-checkbox v-model="stepTemplateSelected.loop">循环</el-checkbox>
            </div>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button
            type="danger"
            @click="onSubmit"
            :disabled="this.$route.params.id > 0 && !updateAllow">
            <span v-if="this.$route.params.id > 0">保存修改</span>
            <span v-else>立即创建</span>
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <el-dialog
      title="批量添加用户"
      :visible.sync="dialogBatchUserListVisible"
      width="400px">
      <el-input v-model="dialogTextareaValue"
                placeholder="输入用户ID英文逗号分隔，示例：669,670,671,672"
                type="textarea"
                :autosize="{ minRows: 5 }"
                resize="none"></el-input>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogBatchUserListVisible = false; dialogTextareaValue = ''">取 消</el-button>
        <el-button type="primary"
                   :disabled="dialogTextareaValue === ''"
                   @click="addBatchToUserList(dialogTextareaValue); dialogTextareaValue = ''">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="批量添加用户标签"
      :visible.sync="dialogBatchUserTagListVisible"
      width="400px">
      <el-input v-model="dialogTextareaValue"
                placeholder="输入用户标签ID英文逗号分隔，示例：669,670,671,672"
                type="textarea"
                :autosize="{ minRows: 5 }"
                resize="none"></el-input>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogBatchUserTagListVisible = false; dialogTextareaValue = ''">取 消</el-button>
        <el-button type="primary"
                   :disabled="dialogTextareaValue === ''"
                   @click="addBatchToUserTagList(dialogTextareaValue); dialogTextareaValue = ''">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import WangEditor from '@components/WangEditorV3Deprecated'
import { taskTplFormRules, taskFormRules } from '../clb-task-template.rules.js'
import selectRemote from '@core/mixins/selectRemote'

export default {
  components: {WangEditor},
  mixins: [selectRemote],
  directives: {
    keyupRegExp: {
      componentUpdated: function (el, {value}) {
        let input = $('input', el)[0]
        let newValue = input.value.replace(value, '')
        if (input.value !== newValue) {
          input.value = newValue
        }
      },
    },
  },
  data () {
    return {
      taskTplFormRules,
      taskFormRules,
      customerItems: [],
      userItems: [],
      userTagItems: [],
      dialogBatchUserListVisible: false,
      dialogBatchUserTagListVisible: false,
      dialogTextareaValue: '',
      taskTplForm: {
        title: '',
        detail: '',
        customerid: '',
      },
      updateAllow: false,
      formExtend: {
        restrictedType: '',
        userList: [],
        userTagList: [],
      },
      form: {
        title: '',
        content: '',
        type: 0,
        hirenum: 1,
        validcheckindistance: 2,
        processingtime: 12,
        reviewtime: 3,
        gpsCheck: 1,
        priority: 0,
        nearby: 1,
        inhouseprior: 0,
        onlynearby: 0,
        superuserprior: 1,
        multitimes: 0,
        rejectuserrepeat: 1,
        rejecttaskrepeat: 1,
        iscsimage: 0,
        iscskeyin: 0,
        ostype: 0,
        prod_type: 0,
        whitelist: '',
        whitelisttags: '',
        blacklist: '',
        blacklisttags: '',
        stepTemplateGroups: [],
      },
      stepTemplateGroup: {
        name: '',
        primary: [],
        secondary: [],
      },
      addStepTemplateButtonDisabled: false,
      stepTemplateAttrs: {
        loop: false,
        required: false,
      },
      stepTemplateToAdded: null, // 待添加的分步模板
      stepTemplateSelected: null, // 已选中活跃的分步模板
      stepTemplateGroupActiveIndex: '0', // 激活的选项卡
      selectLoading: false,
      stepTemplates: [],
    }
  },
  computed: Vuex.mapState({
    typeItems: state => state.clbTaskTemplate.typeOptions,
  }),
  watch: {
    // 选项卡变更活跃选项
    stepTemplateGroupActiveIndex () {
      // 选中模板数据清空
      this.stepTemplateSelected = null
      // 判断该模板是否可以被添加
      this.stepTemplateToAdded && this.stepTemplateToAddedChange(this.stepTemplateToAdded)
    },
    'formExtend.restrictedType' (val) {
      this.form.whitelist = ''
      this.form.whitelisttags = ''
      this.form.blacklist = ''
      this.form.blacklisttags = ''
      if (val === 'white') {
        this.form.whitelist = this.formExtend.userList
        this.form.whitelisttags = this.formExtend.userTagList
      }
      if (val === 'black') {
        this.form.blacklist = this.formExtend.userList
        this.form.blacklisttags = this.formExtend.userTagList
      }
    },
    'formExtend.userList' (val) {
      let restrictedType = this.formExtend.restrictedType
      if (restrictedType === 'white') {
        this.form.whitelist = val.join(',')
      }
      if (restrictedType === 'black') {
        this.form.blacklist = val.join(',')
      }
    },
    'formExtend.userTagList' (val) {
      let restrictedType = this.formExtend.restrictedType
      if (restrictedType === 'white') {
        this.form.whitelisttags = val.join(',')
      }
      if (restrictedType === 'black') {
        this.form.blacklisttags = val.join(',')
      }
    },
  },
  created () {
    this.$store.commit('COLLAPSE_MENU')
    if (this.$route.params.id > 0) {
      this.setTaskTemplate(this.$route.params.id)
    }
  },
  mounted () {
    /* 在挂载到实例上去之后被调用 */
  },
  methods: {
    ...Vuex.mapActions(['getCustomerTable', 'getUserTable', 'getUserTagTable']),
    onSubmit () {
      this.$refs['taskTplForm'].validate((valid) => {
        if (valid) {
          this.$refs['taskForm'].validate((valid) => {
            if (valid) {
              if (this.$route.params.id > 0) {
                this.updateClbTaskTemplate(this.$route.params.id)
              } else {
                this.createClbTaskTemplate()
              }
            } else {
              this.$message.error('提交内容填写不正确！')
            }
          })
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    createClbTaskTemplate () {
      request.common('createClbTaskTemplate', {...this.taskTplForm, json: this.form}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
        }, () => {
          this.$router.push({path: '/clb-task-template/update/' + res.data.id})
        })
      })
    },
    updateClbTaskTemplate (id) {
      request.common('updateClbTaskTemplate', {id, ...this.taskTplForm, json: this.form}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/clb-task-template/table/'})
        })
      })
    },
    setTaskTemplate (id) {
      request.page('getClbTaskTemplate', {id}).then(({data}) => {
        // 客户白名单
        if (data.customerid > 0) {
          request.page('getCustomerDetail', {id: data.customerid}).then(({data}) => {
            this.customerItems.push(data)
          })
        } else {
          delete data.customerid
        }
        // 用户黑白名单 需要拆字符为数组
        if (data.json.whitelist && data.json.whitelisttags) {
          this.formExtend.restrictedType = 'white'
          this.addBatchToUserList(data.json.whitelist)
          this.addBatchToUserTagList(data.json.whitelisttags)
        } else if (data.json.blacklist && data.json.blacklisttags) {
          this.formExtend.restrictedType = 'black'
          this.addBatchToUserList(data.json.blacklist)
          this.addBatchToUserTagList(data.json.blacklisttags)
        }
        filter.setLoop(this.taskTplForm, data)
        filter.setLoop(this.form, _.omit(data.json, ['whitelist', 'whitelisttags', 'blacklist', 'blacklisttags']))
        this.updateAllow = true
      })
    },
    // 添加一个分步模板组
    addStepTemplateGroup (index) {
      this.form.stepTemplateGroups.push({
        ..._.cloneDeep(this.stepTemplateGroup),
        name: '模板组' + (index + 1),
      })
      this.stepTemplateGroupActiveIndex = (this.form.stepTemplateGroups.length - 1).toString()
    },
    // 删除一个分步模板组
    removeStepTemplateGroup (index) {
      this.form.stepTemplateGroups.splice(index, 1)
      this.stepTemplateSelected = null
    },
    // 添加一个分步模板到模板组
    addStepTemplate (type) {
      this.addStepTemplateButtonDisabled = true
      this.getActiveStepTemplateGroup()[type].push({
        id: this.stepTemplateToAdded.id,
        title: this.stepTemplateToAdded.title,
        ...this.stepTemplateAttrs,
      })
    },
    // 删除一个分步模板
    removeStepTemplate (data, index) {
      // 删除了选中的分步模板
      if (this.stepTemplateSelected && this.stepTemplateSelected.id === data[index].id) {
        this.stepTemplateSelected = null
      }
      data.splice(index, 1)
    },
    // 获得当前选中的活跃模板组
    getActiveStepTemplateGroup () {
      return this.form.stepTemplateGroups[this.stepTemplateGroupActiveIndex]
    },
    // 待添加分步模板变化事件
    stepTemplateToAddedChange (value) {
      let stepTemplateGroup = this.getActiveStepTemplateGroup()
      let stepTemplates = [...stepTemplateGroup.primary, ...stepTemplateGroup.secondary]
      let disabled = false
      // 判断是否重复
      for (let key in stepTemplates) {
        if (stepTemplates[key].id === value.id) {
          disabled = true
          break
        }
      }
      // 按钮禁用
      this.addStepTemplateButtonDisabled = disabled
    },
    // 分步模板远程检索列表
    stepTemplateRemoteMethod (query) {
      if (query !== '') {
        this.selectLoading = true
        setTimeout(() => {
          this.selectLoading = false
          request.alert('getStepTemplateTable', {keyword: query, type: 20}).then(({data}) => {
            this.stepTemplates = data.data
          })
        }, 200)
      }
    },
    customerRemoteMethod (query) {
      this.selectRemoteMethod(query, this.getCustomerTable, ({data}) => {
        this.customerItems = data
      })
    },
    userRemoteMethod (query) {
      this.selectRemoteMethod(query, this.getUserTable, ({data}) => {
        this.userItems = data
      })
    },
    userTagRemoteMethod (query) {
      this.selectRemoteMethod(query, this.getUserTagTable, ({data}) => {
        this.userTagItems = data
      })
    },
    arrayValueNotInteger (array) {
      for (let index = 0; index < array.length; index++) {
        const int = array[index]
        if (!Number.isInteger(Number(int))) {
          return int
        }
      }
      return false
    },
    validateIdList (array) {
      if (array.constructor === String) {
        array = array.split(',')
      }
      array = _.remove(array, function (value) {
        return value !== ''
      })
      let validate = this.arrayValueNotInteger(array)
      if (validate) {
        this.$notify({
          title: 'ID错误',
          message: `${validate}不是一个正确的ID`,
          type: 'error',
          duration: 0,
        })
        return false
      }
      return array
    },
    validateDataExist (data, ids, idField) {
      let dataIds = data.map((value) => { return value[idField] })
      let diffIds = _.difference(ids, dataIds)
      if (diffIds.length) {
        this.$notify({
          title: 'ID不存在, 请查证后重试',
          message: `${diffIds.join(',')}`,
          type: 'error',
          duration: 0,
        })
        return false
      } else {
        return dataIds
      }
    },
    addBatchToUserList (ids) {
      ids = this.validateIdList(ids)
      if (!ids) {
        return false
      }
      request.common('getUserTable', {userid: ids}).then(({data}) => {
        let dataIds = this.validateDataExist(data.data, ids, 'userid')
        if (!dataIds) {
          return false
        }
        filter.concatArray(this.userItems, data.data, 'userid')
        filter.concatArray(this.formExtend.userList, ids)
        this.dialogBatchUserListVisible = false
      })
    },
    addBatchToUserTagList (ids) {
      ids = this.validateIdList(ids)
      if (!ids) {
        return false
      }
      request.common('getUserTagTable', {tag_id: ids}).then(({data}) => {
        let dataIds = this.validateDataExist(data.data, ids, 'id')
        if (!dataIds) {
          return false
        }
        filter.concatArray(this.userTagItems, data.data, 'id')
        filter.concatArray(this.formExtend.userTagList, ids)
        this.dialogBatchUserTagListVisible = false
      })
    },
  },
}
</script>
<style lang="scss">

</style>
<style lang="scss"
       scoped>
$--color-danger: #fa5555 !default;
$--border-color-base: #d8dce5 !default;
$--color-text-placeholder: #b4bccc !default;
.step-template-panel {
  border: 1px solid $--border-color-base;
  border-radius: 4px;

  .step-template-container {
    padding: 10px 15px 0px;
    overflow: hidden;

    &.border-bottom {
      border-bottom: 1px solid $--border-color-base;
    }

    .step-template-type {
      padding-right: 15px;
      padding-bottom: 10px;
      float: left;
    }

    .step-template-radio-container {
      margin-left: 57px;

      .step-template-name {
        padding-right: 14px;
      }

      .step-template-remove {
        position: absolute;
        right: 8px;
        top: 8px;
        color: $--color-text-placeholder;

        &:hover {
          color: $--color-danger;
        }
      }

      .step-template-radio {
        margin: 0px 10px 10px 0px;

        .el-radio__input {
          display: none;
        }

        .el-radio__label {
          padding-left: 0px;
        }
      }

      .step-template-icon {
        i {
          // background-color: $--color-text-placeholder;
          color: $--color-text-placeholder;
          margin-left: 2px;
          font-size: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/clb-task-template/pages/ClbTaskTemplateForm.vue